import { ProductType } from '../types';
import { useParams } from 'react-router-dom';
import { AccessProtectedPage } from './AccessProtectedPage';
import { useCallback } from 'react';
import SGReports from './components/SGReports';

export const ReportsPage = () => {
  const { previewKey } = useParams();

  const render = useCallback(() => <SGReports />, []);

  return (
    <AccessProtectedPage
      overrideCheck={previewKey != null}
      productType={ProductType.REPORTS}
      renderContent={render}
    />
  );
};
